(function () {
  const productForm = document.querySelector('product-form');
  if (!productForm) return;

  const bottom = productForm.getBoundingClientRect().bottom;
  let lastKnownScrollPosition = 0;
  let ticking = false;

  function handleStickyAddToCart(scrollPos) {
    const stickyBanner = document.querySelector('.sticky-add-to-cart-banner');
    const windowBottom = window.innerHeight + window.scrollY;
    const documentHeight = document.documentElement.scrollHeight;

    // Hide sticky add to cart if at the bottom of the page
    if (windowBottom >= documentHeight - 600) {
      stickyBanner.setAttribute('data-visible', 'false');
      return;
    }

    if (scrollPos > bottom) {
      stickyBanner.setAttribute('data-visible', 'true');
    } else {
      stickyBanner.setAttribute('data-visible', 'false');
    }
  }

  // Listen to page scrolling to trigger sticky add to cart
  document.addEventListener('scroll', function (event) {
    lastKnownScrollPosition = window.scrollY;

    if (!ticking) {
      window.requestAnimationFrame(() => {
        handleStickyAddToCart(lastKnownScrollPosition);
        ticking = false;
      });
      ticking = true;
    }
  });
})();
